import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {TestConfigMenuItem} from "./test-config-item.enum";

@Injectable({
  providedIn: 'root'
})
export class TestConfigRouterUtil {

  private static readonly TEST_CONFIG_URL = '/quiz/';

  private static readonly menuItems: TestConfigMenuItem[] = [
    TestConfigMenuItem.BASIC_SETTINGS,
    TestConfigMenuItem.QUESTION_MANAGER,
    TestConfigMenuItem.ADVANCED_SETTINGS,
    TestConfigMenuItem.RESPONDENT_MONITORING,
    TestConfigMenuItem.RESULTS_TABLE
  ];

  protected currentRoute!: string;

  constructor(
    private readonly router: Router
  ) {
    if (this.noAnyMenuItemActive()) {
      this.navigateToPage(TestConfigMenuItem.BASIC_SETTINGS);
    }
  }

  get getMenuItems() {
    return TestConfigRouterUtil.menuItems;
  }

  get commonUrl() {
    return TestConfigRouterUtil.TEST_CONFIG_URL;
  }

  public navigateToPage(item: TestConfigMenuItem): void {
    let url = `${this.commonUrl}${this.getRouteByMenuItem(item)}`;
    this.router.navigate([url]).then(() => this.updateCurrentRoute());
  }

  public isRouteActive(item: TestConfigMenuItem) {
    this.updateCurrentRoute();
    return this.currentRoute.includes(
      this.getRouteByMenuItem(item)
    );
  }

  private getRouteByMenuItem(item: TestConfigMenuItem): string {
    return this.getUrl(item);
  }

  private updateCurrentRoute() {
    this.currentRoute = this.router.url;
  }

  private noAnyMenuItemActive() {
    this.updateCurrentRoute();
    let noActiveItem = true;
    this.getMenuItems.forEach(item => {
      if (this.isRouteActive(item)) {
        noActiveItem = false;
      }
    });
    return noActiveItem;
  }

  private getUrl(item: TestConfigMenuItem): string {
    switch (item) {
      case TestConfigMenuItem.BASIC_SETTINGS:
        return 'add';
      case TestConfigMenuItem.QUESTION_MANAGER:
        return 'question/manager';
      case TestConfigMenuItem.ADVANCED_SETTINGS:
        return 'other/settings';
      case TestConfigMenuItem.RESPONDENT_MONITORING:
        return 'respondent/monitoring';
      case TestConfigMenuItem.RESULTS_TABLE:
        return 'results/table';
      default:
        throw new Error("Wrong menu item") ;
    }
  }
}
